import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon } from '@heroicons/react/24/outline';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container-custom py-12">
        <Link to="/" className="inline-flex items-center text-medical-600 hover:text-medical-700 mb-8">
          <HomeIcon className="w-5 h-5 mr-2" />
          Voltar para Home
        </Link>

        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-6 text-gradient">Terms of Service</h1>
          <p className="text-gray-600 mb-8">Última atualização: 12 de outubro de 2025</p>

          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800">1. Aceitação dos Termos</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Ao acessar e usar a plataforma AudFast, você concorda com estes Termos de Serviço.
              Se não concordar com algum termo, não utilize a plataforma.
            </p>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800">2. Descrição do Serviço</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              A AudFast é uma plataforma de gestão audiométrica ocupacional que oferece:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 mb-4">
              <li>Análise de exames audiométricos com inteligência artificial</li>
              <li>Geração automática de laudos técnicos</li>
              <li>Análise de nexo causal conforme NR-7 e Portaria 19/98</li>
              <li>Gestão de histórico audiométrico de pacientes</li>
            </ul>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800">3. Responsabilidades do Usuário</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Você concorda em:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 mb-4">
              <li>Fornecer informações precisas e atualizadas</li>
              <li>Manter a confidencialidade de suas credenciais de acesso</li>
              <li>Usar a plataforma apenas para fins legítimos e profissionais</li>
              <li>Não violar direitos de propriedade intelectual</li>
              <li>Cumprir legislação aplicável (LGPD, NR-7, etc.)</li>
            </ul>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800">4. Responsabilidade Profissional</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              A AudFast é uma ferramenta de apoio à decisão. A responsabilidade técnica e legal
              pelos laudos e diagnósticos permanece exclusivamente com o profissional habilitado.
              Nossa IA fornece análises baseadas em critérios técnicos, mas o julgamento final
              é sempre do profissional de saúde.
            </p>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800">5. Propriedade Intelectual</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Todo conteúdo, algoritmos, design e código da plataforma são propriedade da AudFast.
              Você mantém os direitos sobre os dados que insere, mas nos concede licença para
              processá-los conforme necessário para prestar o serviço.
            </p>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800">6. Limitação de Responsabilidade</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              A AudFast não se responsabiliza por:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 mb-4">
              <li>Decisões clínicas baseadas exclusivamente nas análises da plataforma</li>
              <li>Perda de dados devido a falhas de conexão ou hardware do usuário</li>
              <li>Interrupções temporárias do serviço para manutenção</li>
              <li>Uso inadequado ou não autorizado da plataforma</li>
            </ul>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800">7. Cancelamento e Rescisão</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Você pode cancelar sua conta a qualquer momento através das configurações.
              Reservamo-nos o direito de suspender ou encerrar contas que violem estes termos.
            </p>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800">8. Modificações</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Podemos atualizar estes termos periodicamente. Mudanças significativas serão
              comunicadas com antecedência de 30 dias.
            </p>

            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800">9. Contato</h2>
            <p className="text-gray-600 leading-relaxed">
              Para questões sobre estes termos:
              <br />
              E-mail: <a href="mailto:legal@audfast.com" className="text-medical-600 hover:underline">legal@audfast.com</a>
              <br />
              <Link to="/contact" className="text-medical-600 hover:underline">Formulário de Contato</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
